var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "fill-none",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 125.88 20.07",
        height: "20",
        width: "126",
      },
    },
    [
      _c("polyline", {
        attrs: {
          points:
            "2.94 17.43 16.44 6.93 31.94 19.43 47.44 6.93 62.94 19.43 78.44 6.93 93.94 19.43 109.44 6.93 122.94 17.43",
        },
      }),
      _vm._v(" "),
      _c("polyline", {
        staticClass: "stroke-3",
        attrs: {
          points:
            "0.94 14.43 16.44 1.93 31.94 14.43 47.44 1.93 62.94 14.43 78.44 1.93 93.94 14.43 109.44 1.93 124.94 14.43",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }